// import React from "react";
// import * as actions from '../Actions';
// import './WeekSlider.css';

// function getWeekClass(eleRef, result, weekKey) {
//     if (eleRef.state.currentweek == parseInt(result[weekKey]) && (eleRef.state.IsExpected && global.ftk != "") && eleRef.state.clickwedWeek == parseInt(result[weekKey])) {
//         return "current_li sel-week";
//     } else if (eleRef.state.currentweek == parseInt(result[weekKey]) && (eleRef.state.IsExpected && global.ftk != "") && eleRef.state.clickwedWeek != parseInt(result[weekKey])) {
//         return "current_li";
//     } else if (eleRef.state.clickwedWeek == parseInt(result[weekKey])) {
//         return "sel-week";
//     } else {
//         return "";
//     }
// }

// export default function WeekSlider({ eleRef, WeekBdata, weekKey, keyVal, tool }) {
//     return (
//         <div className="week-slider">
//             <div className="weeks-section" id="slide_block">
//                 <ul className="week-bar" id="profiles_block">
//                     {WeekBdata && WeekBdata.length > 0 && WeekBdata.map(result =>
//                         <li key={parseInt(result[weekKey])} id={'week_' + parseInt(result[weekKey])} className={getWeekClass(eleRef, result, weekKey)} onClick={() => { actions.weekInfo((parseInt(result[weekKey])), eleRef, keyVal, tool) }}>
//                             <div className="allweeks" id={parseInt(result[weekKey])}>
//                                 {tool == 'pis' && <span className="wk-line"></span>}
//                                 <span className="week" id={parseInt(result[weekKey])}>
//                                     <span className="weeknum">{parseInt(result[weekKey])}</span>
//                                 </span>
//                                 {eleRef.state.currentweek == parseInt(result[weekKey]) && (eleRef.state.IsExpected && global.ftk != "") ?
//                                     <span className="wk-txt">Current <br /> Week</span>
//                                     :
//                                     <span className="wk-txt"> Week</span>
//                                 }
//                             </div>
//                         </li>
//                     )}
//                 </ul>
//             </div>
//             <span className="week-next" data-icon-font="h" onClick={() => { actions.slideRight(eleRef.state.clickwedWeek, keyVal, eleRef, tool) }}></span>
//             <span className="week-prev" data-icon-font="g" onClick={() => { actions.slideLeft(eleRef.state.clickwedWeek, keyVal, eleRef, tool) }}></span>
//         </div>
//     );
// }


import React, { useEffect } from "react";
import * as actions from '../Actions';
import './WeekSlider.css';

function scrollToCurrentWeek(currentWeek) {
  try {
    const weekBarEl = document.querySelector('.week-bar');
    const selectedEl = document.querySelector(`#week_${currentWeek}`);
    console.log('🧭 scrollToCurrentWeek', { currentWeek, weekBarEl, selectedEl });

    if (!weekBarEl || !selectedEl) {
      console.warn('⚠️ scrollToCurrentWeek: required elements not found');
      return;
    }

    const containerWidth = weekBarEl.offsetWidth;
    const itemOffsetLeft = selectedEl.offsetLeft;
    const itemWidth = selectedEl.offsetWidth;
    const scrollLeft = Math.max(0, itemOffsetLeft - containerWidth / 2 + itemWidth / 2);

    weekBarEl.scrollLeft = scrollLeft;
    console.log('✅ scrolled', { scrollLeft, containerWidth, itemOffsetLeft, itemWidth });
  } catch (err) {
    console.error('❌ scrollToCurrentWeek error', err);
  }
}

function getWeekClass(eleRef, result, weekKey) {
  const weekValue = parseInt(result[weekKey]);
  const { currentweek, IsExpected, clickwedWeek } = eleRef.state || {};
  const isExpected = IsExpected && global.ftk !== "";

  if (currentweek === weekValue && isExpected && clickwedWeek === weekValue) return "current_li sel-week";
  if (currentweek === weekValue && isExpected && clickwedWeek !== weekValue) return "current_li";
  if (clickwedWeek === weekValue) return "sel-week";
  return "";
}

export default function WeekSlider({ eleRef, WeekBdata, weekKey, keyVal, tool }) {
  // scroll to current week when WeekBdata or currentweek changes
  useEffect(() => {
    const currentWeek = eleRef?.state?.currentweek;
    if (currentWeek && WeekBdata && WeekBdata.length > 0) {
      // small timeout to ensure DOM is painted (optional)
      setTimeout(() => scrollToCurrentWeek(currentWeek), 50);
    } else {
      console.log('🟡 WeekSlider useEffect skipped — data or currentWeek missing', { currentWeek, weekDataCount: WeekBdata?.length });
    }
    // we intentionally depend on WeekBdata length and currentweek
  }, [WeekBdata?.length, eleRef?.state?.currentweek]);

  return (
    <div className="week-slider">
      <div className="weeks-section" id="slide_block">
        <ul className="week-bar" id="profiles_block">
          {WeekBdata && WeekBdata.length > 0 ? WeekBdata.map((result) => {
            const weekValue = parseInt(result[weekKey]);
            const liClass = getWeekClass(eleRef, result, weekKey);

            return (
              <li key={weekValue} id={'week_' + weekValue} className={liClass}
                  onClick={() => { console.log('🖱️ clicked week', weekValue); actions.weekInfo(weekValue, eleRef, keyVal, tool); }}>
                <div className="allweeks" id={weekValue}>
                  {tool === 'pis' && <span className="wk-line"></span>}
                  <span className="week" id={weekValue}>
                    <span className="weeknum">{weekValue}</span>
                  </span>
                  {eleRef.state.currentweek === weekValue && (eleRef.state.IsExpected && global.ftk !== "") ? (
                    <span className="wk-txt">Current <br /> Week</span>
                  ) : (
                    <span className="wk-txt">Week</span>
                  )}
                </div>
              </li>
            );
          }) : <li className="no-data">No Week Data Found</li>}
        </ul>
      </div>

      <span className="week-next" data-icon-font="h" onClick={() => { console.log("➡️ next clicked"); actions.slideRight(eleRef.state.clickwedWeek, keyVal, eleRef, tool); }}></span>
      <span className="week-prev" data-icon-font="g" onClick={() => { console.log("⬅️ prev clicked"); actions.slideLeft(eleRef.state.clickwedWeek, keyVal, eleRef, tool); }}></span>
    </div>
  );
}

